import { Stack, useTheme } from "@mui/material";
import { RENT_DRAWDOWN_OPTIONS } from "web_myplann/Goals/Components/AmountSections/RentDrawdownOptions";
import type { RentDrawdownMode } from "web_myplann/Goals/Forms/useGoalForm";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { SelectableCardButton } from "web_myplann/Shared/Components/SelectableCardButton";

type Props = {
	value: RentDrawdownMode;
	onChange: (value: RentDrawdownMode) => void;
};

export const RentDrawdownPicker: React.FC<Props> = ({ value, onChange }) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack
			direction="row"
			gap={1}
			px={1.6}
			py={1.5}
			borderBottom={`1px solid ${theme.palette.grey[100]}`}
		>
			{RENT_DRAWDOWN_OPTIONS.map(
				({ value: optionValue, labelKey, icon: Icon }) => {
					const selected = value === optionValue;
					return (
						<SelectableCardButton
							key={optionValue}
							selected={selected}
							onClick={() => onChange(optionValue)}
							label={t(labelKey)}
							icon={
								<Icon
									size={20}
									color={
										selected
											? theme.palette.primary.main
											: theme.palette.grey[400]
									}
								/>
							}
						/>
					);
				},
			)}
		</Stack>
	);
};
